import React from "react";
import {
  Navigation,
  RequiredDashboardData,
} from "@nju/feature-portal-dashboard";
import { Footer } from "@nju/feature-portal-footer";
import { Header } from "@nju/feature-portal-header";
import { BlikConfirmPage } from "@nju/feature-portal-order";
import { BlockContent, LayoutWrapper } from "@nju/ui";
import { ClientSideOnly } from "../../../../components/ClientSideRenderer";

export default function Payment() {
  return (
    <LayoutWrapper>
      <Header />
      <BlockContent grid="narrow" spacing="xl" tone="gray">
        <ClientSideOnly>
          <RequiredDashboardData extendedMode="mobile">
            <Navigation title="płatności" />
            <BlikConfirmPage />
          </RequiredDashboardData>
        </ClientSideOnly>
      </BlockContent>
      <Footer />
    </LayoutWrapper>
  );
}
